module.exports = __webpack_public_path__ + "img/6.0-gallery.dc442ec9.jpg";